
import { defineComponent, watch } from 'vue';
import { dialogState as dialog } from '@/plugins/app-dialog/dialog-state';
import { useVModal } from '@/plugins/modal/v-modal';

export default defineComponent({
    name: 'ap-dialog',
    setup() {
        const DIALOG_NAME = 'app-dialog-name';

        const { open, close } = useVModal();

        function reset() {
            dialog.visible = false;
            dialog.title = '';
            dialog.message = '';
            dialog.confirmText = 'Yes';
            dialog.cancelText = 'No';
            dialog.resolver = undefined;
        }

        function submit(value: boolean) {
            const resolver = dialog.resolver;
            reset();
            resolver?.(value);
        }

        watch(
            () => dialog.visible,
            visible => {
                if (visible) open({ name: DIALOG_NAME });
                else close({ name: DIALOG_NAME });
            }
        );

        return { dialog, DIALOG_NAME, submit };
    }
});
